import { ChatState } from '@ui-furniture/common/chat-ui';

import { WebChatUserInputTools } from './web-chat-user-input-tools';

export const createWebChatTools = (chatState: ChatState) => {
  const { setInput, pushBotMessage, processUserResponse } = chatState.controls;
  const inputFactory = new WebChatUserInputTools({
    setChatInput: setInput,
    showUserResponse: processUserResponse,
  });

  return {
    say: (messages: string | Array<string>) => () => {
      if (typeof messages === 'string') pushBotMessage(messages);
      else messages.forEach((message) => pushBotMessage(message));
    },
    ...inputFactory,
  };
};
